import * as React from 'react'

import { UI } from 'components/_Assets/svg/Icon/ui'
import { Button, TYPE } from 'components/Button'
import Icon from 'components/Icon'

import './FormQuantity.scss'

interface FormQuantityProps {
  type: string
  heading: string | JSX.Element
  subHeading?: string | JSX.Element
  defaultQuantity?: number
  max?: number
  min?: number
  onChange?: (num: number) => void
}

interface FormQuantityState {
  quantity: number
}

class FormQuantity extends React.Component<
  FormQuantityProps,
  FormQuantityState
> {
  public static defaultProps = { defaultQuantity: 0, min: 0 }

  constructor(props: FormQuantityProps) {
    super(props)
    this.state = {
      quantity: props.defaultQuantity || 0,
    }
    this.handlePlus = this.handlePlus.bind(this)
    this.handleMinus = this.handleMinus.bind(this)
  }

  public setStateAndHook(quan: number) {
    this.setState({
      quantity: quan,
    })
    if (this.props.onChange) {
      this.props.onChange(quan)
    }
  }

  public handlePlus() {
    const quan = this.state.quantity + 1
    if (!(this.props.max !== undefined && quan > this.props.max)) {
      this.setStateAndHook(quan)
    }
  }

  public handleMinus() {
    const quan = this.state.quantity - 1
    if (!(this.props.min !== undefined && quan < this.props.min)) {
      this.setStateAndHook(quan)
    }
  }

  public componentDidUpdate() {
    if (this.props.max && this.props.max < this.state.quantity) {
      this.setState({ quantity: this.props.max })
      if (this.props.onChange) {
        this.props.onChange(this.props.max)
      }
    }
  }

  public render() {
    return (
      <div
        className={`srprs-formQuantity${
          this.props.type === 'inside' ? ' is-inside' : ' is-outside'
        }`}
      >
        <div className="label">
          <strong>
            {this.props.type === 'outside' ? (
              <span className={'quantity-outside'}>{this.state.quantity} </span>
            ) : null}
            {this.props.heading}
          </strong>
          {this.props.subHeading ? (
            <span className={'subheading'}>{this.props.subHeading}</span>
          ) : null}
        </div>
        <div className={'button-minus'}>
          <Button type={TYPE.circle} negative={true} onClick={this.handleMinus}>
            <Icon icon={UI.minus} />
          </Button>
        </div>
        {this.props.type === 'inside' ? (
          <div className={'quantity-inside'}>{this.state.quantity}</div>
        ) : null}
        <div className={'button-plus'}>
          <Button type={TYPE.circle} negative={true} onClick={this.handlePlus}>
            <Icon icon={UI.plus} />
          </Button>
        </div>
      </div>
    )
  }
}

export default FormQuantity
